<template>
  <div>21212</div>
</template>

<script>
export default {
  name: "jump",
  data() {
    return {};
  },
  methods: {},
  mounted() {
    this.$router.push({
      path: "/reportInfo/report?id=" + this.$route.query.id + "&smslink=" + 1
    });
  },
  created() {}
};
</script>

<style scoped>
</style>
